import styled, { css } from "styled-components/macro";

import { baseButtonStyles } from "../../styles/sharedStyles";

export const Block = styled.div<{bgcolor: string}>`
  padding: 20px 40px 40px;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ bgcolor }) => bgcolor};
    
    &:not(:last-child) {
      margin-bottom: 55px;  
    }

  @media (max-width: 1439px) {
     padding: 26px 26px 40px;
     gap: 24px;
    
     &:not(:last-child) {
       margin-bottom: 12px;
     }
  }

  @media (max-width: 979px) {
    flex-direction: column;
    padding: 16px 16px 32px;
    gap: 0;
  }
`

export const BlockTitle = styled.h2<{isWhite?: boolean}>`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 57px;
  font-weight: 600;
  line-height: 105%;
  color: ${({ isWhite }) => isWhite ? "#fff" : ""};

  @media (max-width: 1439px) {
    font-size: 45px;
    line-height: 105%;
  }

  @media (max-width: 979px) {
    font-size: 38px;
    margin-bottom: 30px;
  }
`

export const BlockDescription = styled.div`
  max-width: 720px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1439px) {
    max-width: 640px;
  }
`

export const Text = styled.p<{isWhite?: boolean}>`
  font-size: 22px;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 26px;
  padding-top: 11px;
  letter-spacing: -0.02em;
  color: ${({ isWhite }) => isWhite ? "#fff" : ""};

  @media (max-width: 979px) {
    font-size: 16px;
    padding-top: 0;
    margin-bottom: 30px;
  }
`

export const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const StyledButton = styled.a<{isWhite?: boolean}>`
  ${baseButtonStyles};
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  background-color: transparent;

  ${({ isWhite }) => isWhite
    ? css`
        color: #fff;
        border-color: #fff;
    `
    : "" };

  @media (max-width: 979px) {
    font-size: 16px;
    width: auto;
  }
  
  @media (max-width: 429px) {
    //padding: 0 5px;
  }
  
  
`

